import { expected, format } from '@aloft/toolkit-shared';

import {
  Bar,
  BarChart,
  CartesianGrid,
  Label,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { BAR_COLOR, BAR_COLOR_2 } from './consts.ts';
import { SiteToValueRatioChartData } from './types.ts';

export const SiteToValueRatioChartUnwrapped = ({
  data,
  isLoading = false,
  disableAnimations = false,
  width,
  height,
  dots,
}: {
  data: SiteToValueRatioChartData[];
  isLoading?: boolean;
  disableAnimations?: boolean;
  width?: number;
  height?: number;
  dots?: string;
}) => (
  <ResponsiveContainer width={width ?? '100%'} height={height ?? 300}>
    <BarChart data={data} barGap={0}>
      <CartesianGrid vertical={false} />
      <Legend />
      {!disableAnimations && <Tooltip formatter={(val): string => expected(format.percent(val))} />}
      <YAxis
        orientation="left"
        tickFormatter={(val) => expected(format.percent(val, 0))}
        width={80} // to accommodate the label
      >
        <Label angle={-90} position="left" offset={-5}>
          Site to Value Ratio
        </Label>
      </YAxis>
      <XAxis dataKey="siteName" />
      <Bar
        name={`Assessor's Land to Value Ratio${isLoading ? ` (loading${dots ?? ''})` : ''}`}
        dataKey="marketLandToValueRatio"
        fill={BAR_COLOR_2}
        isAnimationActive={!disableAnimations}
      />
      <Bar
        name="Site to Value Ratio"
        dataKey="siteToValueRatio"
        fill={BAR_COLOR}
        isAnimationActive={!disableAnimations}
      />
    </BarChart>
  </ResponsiveContainer>
);
